import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    OnInit,
    Output,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
    BaseSiteService,
    CmsService,
    OccEndpointsService,
    RoutingService,
} from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { CustomProfileAndPreferencesService } from 'src/app/custom-profile-and-preferences/custom-profile-and-preferences.service';
import { SharedService } from 'src/app/shared/services/shared.service';
import { BaseService } from '../../../app/shared/services/base.service';
import * as constants from '../constants';
import { ReturnService } from '../return.service';

@Component({
    selector: 'app-create-return',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './create-return.component.html',
    styleUrls: ['./create-return.component.scss'],
    standalone: false
})
export class CreateReturnComponent implements OnInit {
  constantsValue = constants;
  productList = [];
  productSelected = false;
  isUnitSelected = false;
  isRadioSelected = false;
  contentMsg: any;
  cmsRespons: any;
  validEmail = false;
  todayDate = new Date().toLocaleDateString('en-US');
  isValidated = false;
  emailRequired = '';
  emailOptional1 = '';
  emailOptional2 = '';
  emailRequiredValid = true;
  emailOptional1Valid = true;
  emailOptional2Valid = true;
  userInfo: any;
  pdfUrl: any;
  baseUrl: any;
  downloadRAUrl: any;
  returnKey: any;
  noOfBoxes = '0';
  userDetails: any;
  downlodUrl: any;
  userAccountSub: Subscription;
  baseSiteId = '';
  @Output() navigateHistoryEvent = new EventEmitter<boolean>();
  constructor(
    private readonly cmsData: CmsService,
    private readonly returnService: ReturnService,
    private readonly modalService: NgbModal,
    private readonly user: UserAccountFacade,
    private readonly baseService: BaseService,
    private readonly pfService: CustomProfileAndPreferencesService,
    private readonly cd: ChangeDetectorRef,
    private readonly occEndPoint: OccEndpointsService,
    private readonly sanitizer: DomSanitizer,
    private readonly sharedService: SharedService,
    private readonly baseSiteService: BaseSiteService,
    private readonly route: RoutingService
  ) {
    this.baseUrl = this.occEndPoint.getBaseUrl({
      baseUrl: true,
      prefix: false,
      baseSite: false,
    });
  }
  cmsSub: Subscription;
  cmsSub2: Subscription;
  baseSub: Subscription;
  returnSub: Subscription;
  returnSub2: Subscription;

  ngOnInit(): void {
    this.cmsSub = this.cmsData
      .getComponentData('returnInamrParagraphComponent')
      .subscribe((res) => {
        this.cmsRespons = res;
        this.contentMsg = this.cmsRespons?.content;
      });
    this.cmsSub2 = this.cmsData
      .getComponentData('pdfReservationGuideComponent')
      .subscribe((res) => {
        let termCondition: any = JSON.parse(JSON.stringify(res));
        this.pdfUrl = this.baseUrl + termCondition?.document?.url;
      });

    this.userDetails = {
      userName: this.sharedService.getLocalStorage('userId'),
    };
    this.pfService.getUserAccountDetailsDataFromDb(
      this.userDetails.userName,
      this.sharedService.getLocalStorage('accountId')
    );
    this.userAccountSub = this.pfService.userAccountDetails.subscribe(
      (data) => {
        if (data) {
          this.userInfo = data.res;
          this.cd.detectChanges();
        }
      }
    );

    this.baseSub = this.baseSiteService
      .getActive()
      .pipe(take(1))
      .subscribe((res) => (this.baseSiteId = res));
  }
  ngOnDestroy(): void {
    this.cmsSub?.unsubscribe();
    this.cmsSub2?.unsubscribe();
    this.baseSub?.unsubscribe();
    this.returnSub?.unsubscribe();
    this.returnSub2?.unsubscribe();
    this.userAccountSub?.unsubscribe();
  }
  performQuantityComputation(operator, event) {
    if (event) {
    } else {
      if (operator === 'plus') this.noOfBoxes = String(+this.noOfBoxes + 1);
      else if (operator === 'minus')
        this.noOfBoxes = String(+this.noOfBoxes - 1);
    }
    this.isUnitSelected = true;
    if (this.noOfBoxes === '0' || this.noOfBoxes === '')
      this.isUnitSelected = false;
    this.validateSubmit();

    this.cd.detectChanges();
  }

  count = 0;
  getSelectedProduct(product) {
    let productName = product.baseProductInfo.baseProductDescription + product.baseProductInfo.variantInfo[0].description + ' (' + product.code + ')';
    this.count+=1;
    this.productList.push({ name: productName, productCode: product.code, lotNumber: '', returnDoses: 0, ndcNumber: product.baseProductInfo.variantInfo[0]?.ndcCode ? product.baseProductInfo.variantInfo[0]?.ndcCode : '', id: this.count });
    this.productSelected = true;
    this.validateSubmit();
  }








  deletePopup(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  removeProduct(item, popover) {
    this.productList.splice(this.productList.findIndex(x => x.id === item.id), 1); //NEW RETURNS

    if(this.productList.length === 0) this.productSelected = false;
    popover.close();
    this.validateSubmit();
  }

  submitRequest(content) {
    let tempReturnList = this.productList.map(
      ({ productCode, lotNumber, returnDoses, ndcNumber }) => ({
        productCode,
        lotNumber,
        returnDoses,
        ndcNumber,
      })
    );
    let emailList = [];
    emailList.push(this.emailRequired);
    if (this.emailOptional1) emailList.push(this.emailOptional1);
    if (this.emailOptional2) emailList.push(this.emailOptional1);
    let objectParam = {
      productDetails: tempReturnList,
      emailList: emailList,
      noOfBoxes: this.noOfBoxes,
    };
    this.returnSub = this.returnService
      .postSubmitRequest(objectParam, this.userDetails.userName)
      .subscribe((data) => {
        this.downloadRAUrl = data.raLabelurls[0];
        this.returnKey = data.returnKey;
        this.modalService.open(content, {
          centered: true,
          backdrop: 'static',
          windowClass: `returnSuccessModal ${this.baseSiteId}`,
        });
        const bodyEle = document.querySelector('.body-style');
        setTimeout(() => {
          bodyEle.scrollTop = 0;
        }, 100);
      });
  }

  validateInput(event, type) {
    if (type === 'noOfBox') {
      if (
        event.keyCode === 69 ||
        (event.target.value === '' && event.keyCode === 48) ||
        (event.target.value === '' && event.keyCode === 96)
      ) {
        return false;
      } else {
        let reg = /^[^`!@#~$%\^&*()_+\-={};':"\\|[\]\\.,<>/\/?~]*$/;
        return new RegExp(reg).test(event.key);
      }
    } else {
      let reg = /^[^`!@#~$%\^&*()_+\-={};':"\\|[\]\\.,<>/\/?~]*$/;
      return new RegExp(reg).test(event.key);
    }
  }

  validateEmail(email, field) {
    const emailElement = document.getElementById('email') as HTMLInputElement;
    const opt1Element = document.getElementById(
      'emailOpt1'
    ) as HTMLInputElement;
    const opt2Element = document.getElementById(
      'emailOpt2'
    ) as HTMLInputElement;
    let regEx = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,15}$/);
    if (emailElement.value) {
      if (regEx.test(emailElement.value)) {
        this.validEmail = true;
        this.emailRequiredValid = true;
        if (opt1Element.value) {
          if (regEx.test(opt1Element.value)) {
            this.validEmail = true;
            this.emailOptional1Valid = true;
          } else {
            this.validEmail = false;
            this.emailOptional1Valid = false;
            this.validateSubmit();
            return;
          }
        }
        if (opt2Element.value) {
          if (regEx.test(opt2Element.value)) {
            this.validEmail = true;
            this.emailOptional2Valid = true;
          } else {
            this.validEmail = false;
            this.emailOptional2Valid = false;
            this.validateSubmit();
            return;
          }
        }
      } else {
        this.validEmail = false;
        this.emailRequiredValid = false;
        this.validateSubmit();
        return;
      }
    } else {
      this.emailRequiredValid = true;
      this.validEmail = false;
      if (opt1Element.value) {
        if (regEx.test(opt1Element.value)) {
          this.emailOptional1Valid = true;
        } else {
          this.validEmail = false;
          this.emailOptional1Valid = false;
          this.validateSubmit();
          return;
        }
      }
      if (opt2Element.value) {
        if (regEx.test(opt2Element.value)) {
          this.emailOptional2Valid = true;
        } else {
          this.validEmail = false;
          this.emailOptional2Valid = false;
          this.validateSubmit();
          return;
        }
      }
    }
    this.validateSubmit();
  }

  OnPrint() {
    window.print();
  }

  validateSubmit() {

    if (this.productList.length > 0 && this.productList.every(el => !!el.returnDoses) &&
    this.isUnitSelected && this.isRadioSelected && this.validEmail) {
      this.isValidated = true;
    } else {
      this.isValidated = false;
    }
  }

  radioSelected() {
    this.isRadioSelected = !this.isRadioSelected;
    this.validateSubmit();
  }

  updateLotDoses(value, field, id) {
    this.productList.filter(x => x.id === id).map((c) => {
      if (field === 'lotno')
        c.lotNumber = value;
      else if (field === 'doses')
        c.returnDoses = value;
        this.validateSubmit();
    })
  }








  downloadRALabels() {
    window.open(this.downloadRAUrl, '_blank');
  }

  downloadFile() {
    this.returnSub2 = this.returnService
      .getFile(this.userDetails.userName, this.returnKey)
      .subscribe((res) => {
        const file = new Blob([res], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      });
  }
  validateKey(event) {
    if (event.keyCode === 32) {
      return false;
    }
  }

  navigateReturnHistory() {
    this.modalService.dismissAll();
    this.route.goByUrl('/returnpage/returnhistory?page=returnHistory');
    this.productList = [];
    this.noOfBoxes = '0';
    this.emailRequired = '';
    this.emailOptional1 = '';
    this.emailOptional2 = '';
    this.isRadioSelected = false;
    this.isValidated = false;
    this.productSelected = false;
    this.returnService.emitReturnHistory.emit(true);
  }

  onFocusOut() {
    if (!this.noOfBoxes) this.noOfBoxes = '1';
    this.cd.detectChanges();
  }
}
